import React, { PropsWithChildren, useMemo } from 'react';

import { ServiceDisruption, ServiceDisruptionReasonCode } from './service-disrupted';
import { useUserPreferencesQuery } from '../user-preferences/useUserPreferencesQuery';
import { Preferences } from '@/types';
import { createUseContext } from '../../../utils/create-use-context';

type UserPreferencesLoaderProps = object;

export function UserPreferencesLoader(props: PropsWithChildren<UserPreferencesLoaderProps>) {
  const { data, status } = useUserPreferencesQuery();

  if (status === 'pending') {
    // TODO: Loader?
    return null;
  }

  if (status === 'error') {
    // Generic error page
    return (
      <>
        <ServiceDisruption reason={ServiceDisruptionReasonCode.UserPreferencesError} />
      </>
    );
  }

  // Success, continue loading
  return (
    <>
      <UserPreferencesProvider data={data}>
        {props.children}
      </UserPreferencesProvider>
    </>
  )
}

type UserPreferencesProviderProps = {
  data: Preferences
}

function UserPreferencesProvider({ children, data }: PropsWithChildren<UserPreferencesProviderProps>) {
  const contextValue = useMemo(() => {
    return data;
  }, [data]);

  return (
    <UserPreferencesContextProvider value={contextValue}>
      { children }
    </UserPreferencesContextProvider>
  )
}

type ContextValue = Preferences;

const UserPreferencesContext = React.createContext<null | ContextValue>(null);
export const UserPreferencesContextProvider = UserPreferencesContext.Provider;

export const useUserPreferencesLoaderContext = createUseContext(UserPreferencesContext);

